/*  @flow */
import * as React from 'react';

import ActionButton from 'components/ActionsList/components/ActionButton/ActionButton';

import { activities } from 'components/Activity/ActivityData';

import {
  updateEditCostCenter,
  updateAssignProjects,
  updateRemoveProjects,
  updateArchiveCostCenter,
  updateUnarchiveCostCenter,
  toggleCostCenterStatus,
} from 'permissions/costCenter';

const actionsListData: any = [
  {
    label: 'general:actions.edit_cost_center',
    icon: '#icon-edit',
    action: '',
    type: 'link',
    to: { pathname: '/cost-centers/edit', setStateData: true },
    permissions: updateEditCostCenter,
  },
  {
    label: 'general:actions.assign_project_plural',
    icon: '#icon-allocate-to-a-project',
    tag: activities.assignProjectsToCostCenter.tag,
    action: activities.assignProjectsToCostCenter.action,
    permissions: updateAssignProjects,
  },
  {
    label: 'general:actions.remove_project_plural',
    icon: '#icon-remove-from-project',
    tag: activities.removeProjectsFromCostCenter.tag,
    action: activities.removeProjectsFromCostCenter.action,
    permissions: updateRemoveProjects,
  },
  {
    label: 'general:actions.activate_cost_center',
    icon: '#icon-approve',
    tag: activities.activateCostCenter.tag,
    action: activities.activateCostCenter.action,
    permissions: toggleCostCenterStatus,
    condition(costCenter: Object, action: Object, callback: Function): React.Node {
      return !costCenter.status && <ActionButton action={action} onActionDrawer={callback} />;
    },
  },
  {
    label: 'general:actions.disable_cost_center',
    icon: '#icon-disable',
    tag: activities.disableCostCenter.tag,
    action: activities.disableCostCenter.action,
    permissions: toggleCostCenterStatus,
    condition(costCenter: Object, action: Object, callback: Function): React.Node {
      return costCenter.status && <ActionButton action={action} onActionDrawer={callback} />;
    },
  },
  {
    label: 'general:actions.archive_cost_center',
    icon: '#icon-archive',
    tag: activities.archiveCostCenter.tag,
    action: activities.archiveCostCenter.action,
    permissions: updateArchiveCostCenter,
    condition(costCenter: Object, action: Object, callback: Function): React.Node {
      return !costCenter.archived_at && <ActionButton action={action} onActionDrawer={callback} />;
    },
  },
  {
    label: 'general:actions.unarchive_cost_center',
    icon: '#icon-unarchive',
    tag: activities.unarchiveCostCenter.tag,
    action: activities.unarchiveCostCenter.action,
    permissions: updateUnarchiveCostCenter,
    condition(costCenter: Object, action: Object, callback: Function): React.Node {
      return costCenter.archived_at && <ActionButton action={action} onActionDrawer={callback} />;
    },
  },
];

export default actionsListData;
